var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('f-message-box',{attrs:{"type":"info"},scopedSlots:_vm._u([{key:"default",fn:function({ headingSlotClass }){return [_c('h3',{class:headingSlotClass},[_vm._v(_vm._s(_vm.$t("SBRV.RW.meddelanderuta.rubrik.tankpaatt")))]),_vm._t("default")]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }